var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"link btn",on:{"click":_vm.abrirCardapio}},[_vm._v(_vm._s(_vm.textoNoBotao))])}
var staticRenderFns = []

export { render, staticRenderFns }